/* eslint-disable react/react-in-jsx-scope */
// import { Link } from 'react-router-dom';

// MOCK
export const productPageMocks = {
  title: 'Smartphone Samsung Galaxy A14 128GB Preto 4G Octa-Core 4GB RAM 6,6 Câm. Tripla + Selfie 13MP Dual Chip',
  seller: 'Magazine Luiza',
  rate: 3.5,
  favorited: false,
  images: [
    { id: 1, alt: 'Smartphone Samsung', url: '/images/mock-product-images/product-image-01.png' },
    { id: 2, alt: 'Smartphone Samsung', url: '/images/mock-product-images/product-image-02.png' },
    { id: 3, alt: 'Smartphone Samsung', url: '/images/mock-product-images/product-image-03.png' },
    { id: 4, alt: 'Smartphone Samsung', url: '/images/mock-product-images/product-image-04.png' },
    { id: 5, alt: 'Smartphone Samsung', url: '/images/mock-product-images/product-image-05.png' },
  ],
  details: {
    points_value: 4547,
    color_options: [
      { value: 'Preto', label: 'Preto', availability: true },
      { value: 'Azul', label: 'Azul', availability: true },
      { value: 'Verde', label: 'Verde', availability: true },
      { value: 'Vermelho', label: 'Vermelho', availability: true },
    ],
    size_options: [
      { value: '34', label: '34', availability: true },
      { value: '35', label: '35', availability: false },
      { value: '36', label: '36', availability: true },
      { value: '37', label: '37', availability: true },
      { value: '38', label: '38', availability: true },
      { value: '39', label: '39', availability: true },
      { value: '40', label: '40', availability: true },
      { value: '41', label: '41', availability: true },
      { value: '42', label: '42', availability: true },
      { value: '43', label: '43', availability: true },
      { value: '44', label: '44', availability: true },
    ],
    voltage_options: [
      { value: '110v', label: '110v', availability: true },
      { value: '220v', label: '220v', availability: true },
    ],
  },
  shipping: {
    street: 'Rua São Jorge',
    bourgh: 'Jardim Castelo',
    number: 246,
    city: 'Ferraz de Vasconcelos',
    state: 'São Paulo',
    uf: 'SP',
    cep: '08503-150',
    points_value: 25,
    delivery_forecast: '20/11/2023',
    isDeliveryAvailable: true,
  },
  redemptionOptions: [
    { index: 0, value: '2.800 pontos + R$ 7,07 em 1 vez de R$ 7,07' },
    { index: 1, value: '2.800 pontos + R$ 14,13 em 1 vez de R$ 7,07' },
    { index: 2, value: '2.800 pontos + R$ 21,19  em 1 vez de R$ 7,07' },
    { index: 3, value: '2.800 pontos + R$ 21,19  em 1 vez de R$ 7,07' },
  ],
  cardsAccepted: [
    { alt: 'Visa', url: 'http://vertice-ds.s3-website-us-east-1.amazonaws.com/Assets/Images/cards/card_visa.png' },
    { alt: 'Mastercard', url: 'http://vertice-ds.s3-website-us-east-1.amazonaws.com/Assets/Images/cards/card_mastercard.png' },
    { alt: 'Elo', url: 'http://vertice-ds.s3-website-us-east-1.amazonaws.com/Assets/Images/cards/card_elo.png' },
    { alt: 'Hipercard', url: 'http://vertice-ds.s3-website-us-east-1.amazonaws.com/Assets/Images/cards/card_hipercard.png' },
    { alt: 'Diners Club Internacional', url: 'http://vertice-ds.s3-website-us-east-1.amazonaws.com/Assets/Images/cards/card_diners_club_internacional.png' },
    { alt: 'American Express', url: 'http://vertice-ds.s3-website-us-east-1.amazonaws.com/Assets/Images/cards/card_american_express.png' },
  ],
};

export const showcaseRecommendedMock = [
  {
    imageUrl: 'http://vertice-ds.s3-website-us-east-1.amazonaws.com/Assets/Images/sample-product.png',
    name: 'Cartão Virtual Spotify premium com desconto de R$20,00',
    productUrl: '/about',
    rating: { average: 4, totalCount: 6 },
    colProps: {
      className: 'col-12',
    },
    hasExtractValue: true,
    flags: [
      {
        status: 'highlight',
        label: 'Frete Grátis',
      },
      {
        status: 'error',
        label: '10%',
      },
    ],
  },
  {
    imageUrl: 'http://vertice-ds.s3-website-us-east-1.amazonaws.com/Assets/Images/sample-product.png',
    name: 'Cartão Virtual Spotify premium com desconto de R$200,00',
    productUrl: '/about',
    rating: { average: 4, totalCount: 6 },
    colProps: {
      className: 'col-12',
    },
    hasExtractValue: true,
  },
  {
    imageUrl: 'http://vertice-ds.s3-website-us-east-1.amazonaws.com/Assets/Images/sample-product.png',
    name: 'Cartão Virtual Spotify premium com desconto de R$1.000,00',
    productUrl: '/about',
    rating: { average: 4, totalCount: 6 },
    colProps: {
      className: 'col-12',
    },
    hasExtractValue: true,
  },
  {
    imageUrl: 'http://vertice-ds.s3-website-us-east-1.amazonaws.com/Assets/Images/sample-product.png',
    name: 'Cartão Virtual Spotify premium com desconto de R$20,00',
    productUrl: '/about',
    rating: { average: 4, totalCount: 6 },
    colProps: {
      className: 'col-12',
    },
    hasExtractValue: true,
  },
  {
    imageUrl: 'http://vertice-ds.s3-website-us-east-1.amazonaws.com/Assets/Images/sample-product.png',
    name: 'Cartão Virtual Spotify premium com desconto de R$20,00',
    productUrl: '/about',
    rating: { average: 4, totalCount: 6 },
    colProps: {
      className: 'col-12',
    },
    hasExtractValue: true,
  },
  {
    imageUrl: 'http://vertice-ds.s3-website-us-east-1.amazonaws.com/Assets/Images/sample-product.png',
    name: 'Cartão Virtual Spotify premium com desconto de R$20,00',
    productUrl: '/about',
    rating: { average: 4, totalCount: 6 },
    colProps: {
      className: 'col-12',
    },
    hasExtractValue: true,
  },
];
